import React, { Suspense, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDebounced } from '@helpers/useDebounced';
import useOnboardingProcess from '@hooks/useOnboardingProcess';
import { useAuth } from '@hooks/useAuth';
import { apiClient } from '@api/client';
import { useTypedSelector } from '@hooks';
import { useOrganization } from '@components/OrganizationBoundary';

const AnnouncementModal = React.lazy(() => import('./AnnouncementModal'));

export const ANNOUNCEMENT_MEDIA_VIEWER_TOUR_METADATA_KEY =
  'announcement-media-viewer-tour-v5';
const ANNOUNCEMENT_CLOSE_MODAL_KEY = 'announcement-close-modal-v2';

export default function AnnouncementModalContainer() {
  const { user, updateUserProfile } = useAuth(true);
  const bootcampModalState = useTypedSelector(
    ({ modal }) => modal.bootcampModal
  );
  const { tourData, showProcess } = useOnboardingProcess();
  const { currentOrganization } = useOrganization(false);
  const [searchParams] = useSearchParams();
  // const userEmail = user?.email || '';
  // const announcementSeen =
  //   !!currentOrganization?.entity?.features.disableAnnouncements ||
  //   !!user.metadata[METADATA_KEY] ||
  //   userEmail.endsWith('@asu.edu') ||
  //   userEmail.endsWith('@nbcc.ca');
  const announcementSeen =
    !!currentOrganization?.entity?.features.disableAnnouncements ||
    !!user.metadata[ANNOUNCEMENT_CLOSE_MODAL_KEY];

  const hasActiveTour =
    !!searchParams.get('startTour') ||
    !!searchParams.get('welcome') ||
    !!tourData?.type ||
    !!showProcess;
  const isOpen =
    !announcementSeen &&
    !hasActiveTour &&
    !bootcampModalState?.visible &&
    !!user?.id;
  const debouncedIsOpen = useDebounced(isOpen, 4000, false);
  const visibleDebounced = useDebounced(debouncedIsOpen, 300, false);
  const visible = debouncedIsOpen || visibleDebounced;

  const onFinish = useCallback(
    async (isClose = false) => {
      const metadata = {
        ...(user?.metadata || {}),
        [ANNOUNCEMENT_CLOSE_MODAL_KEY]: true,
        ...(!isClose
          ? { [ANNOUNCEMENT_MEDIA_VIEWER_TOUR_METADATA_KEY]: true }
          : {})
      };
      updateUserProfile({
        metadata
      });
      await apiClient.profile.profileControllerUpdateProfileMetadata({
        metadata
      });
    },
    [updateUserProfile]
  );

  if (!visible) return null;

  return (
    <Suspense fallback={null}>
      <AnnouncementModal open={isOpen} onFinish={onFinish} />
    </Suspense>
  );
}
